// emsaccess-app/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import EMSAccess from './EMSAccess';
import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <EMSAccess />
  </BrowserRouter>
);
